import React from "react";
import LegalLayout from "@/components/LegalLayout";
import { site } from "@/config/site";

export default function ServiceDelivery() {
  return (
    <LegalLayout title="Service Delivery Policy" updatedOn="April 2026">
      <p>
        VaultSafe is a fully digital, cloud-based backup service. There is no
        physical product to ship.
      </p>

      <h2>1. Service activation</h2>
      <p>
        Once we receive confirmation of your payment, our team will contact you
        within <strong>one business day</strong> to schedule installation of the
        VaultSafe agent on your computers.
      </p>

      <h2>2. Setup timeline</h2>
      <p>
        Setup is completed remotely (over screen-share) or on-site at your
        office, depending on what is convenient for you. Setup for a typical
        small business is completed within <strong>2–3 business days</strong>{" "}
        of payment.
      </p>

      <h2>3. Service commencement</h2>
      <p>
        Your service is active from the date the agent is successfully installed
        on your first computer and the first backup begins. Your subscription
        term (annual) is measured from this activation date.
      </p>

      <h2>4. Ongoing delivery</h2>
      <p>
        Once set up, backups run automatically every day. Support requests
        (including restore requests) are handled during our business hours:{" "}
        {site.businessHours}.
      </p>

      <h2>5. Communication</h2>
      <p>
        All service-related communication happens over email
        ({site.email}), WhatsApp, or phone. Setup confirmations, invoices, and
        service notices are sent to your registered email address.
      </p>

      <h2>6. Contact</h2>
      <p>
        For any questions about service delivery, write to{" "}
        <a href={`mailto:${site.email}`}>{site.email}</a> or call{" "}
        {site.phoneDisplay}.
      </p>
    </LegalLayout>
  );
}
